/**
 * Omnisend follow MVP: opens/triggers a form and stamps a playlist-specific property hint.
 * Property key: follow_{handle_with_underscores}
 */
(function () {
  function propertyKey(handle, prefix) {
    var safe = String(handle || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
    return (prefix || 'follow_') + safe;
  }

  function openOmnisend(formTarget) {
    if (!formTarget) return false;

    if (formTarget.charAt(0) === '#' || formTarget.charAt(0) === '.') {
      var el = document.querySelector(formTarget);
      if (!el) return false;
      if (typeof el.showModal === 'function') {
        el.showModal();
        return true;
      }
      el.hidden = false;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusable = el.querySelector('input,button,textarea,[tabindex]');
      if (focusable) focusable.focus();
      return true;
    }

    if (window.omnisend && typeof window.omnisend.push === 'function') {
      window.omnisend.push(['openForm', formTarget]);
      return true;
    }

    return false;
  }

  function revealInlineForm(btn) {
    var root = btn.closest('[data-playlist-follow]');
    var form = root && root.querySelector('[data-follow-form]');
    if (!form) return false;

    form.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    var field = form.querySelector('input[type="email"], input:not([type="hidden"])');
    if (field) field.focus();
    return true;
  }

  function initButton(btn) {
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-playlist-handle') || '';
      var prefix = btn.getAttribute('data-property-prefix') || 'follow_';
      var formTarget = btn.getAttribute('data-omnisend-form') || '';
      var key = propertyKey(handle, prefix);
      var root = btn.closest('[data-playlist-follow]');
      var status = root && root.querySelector('[data-follow-status]');

      btn.dataset.omnisendProperty = key;
      document.documentElement.dataset.pendingPlaylistFollow = key;

      if (revealInlineForm(btn)) return;

      var opened = openOmnisend(formTarget);
      if (status) {
        status.hidden = false;
        status.textContent = opened
          ? (btn.getAttribute('data-success-label') || 'Complete the signup form to follow this playlist.')
          : (btn.getAttribute('data-missing-label') || 'Follow form is not configured yet. Set an Omnisend form ID in theme settings.');
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-playlist-follow-button]').forEach(initButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
